// src/belediye/components/tasks/GorevOnayPopover.js
// FAZ-56 (2026-07-28 kullanıcı kararı) — satır-içi aksiyonlar için POPOVER.
//
// ÖNCEDEN: "Ne durumdayız?" ve "İşe Başladım" alttan çekmece (BottomSheet)
// açıyordu. Çekmece ekranın altından gelip tüm listeyi kapatıyordu; oysa bunlar
// tek tıklık işler. ARTIK: tetikleyicinin YANINDA (tercihen solunda) küçük bir
// baloncuk açılır — ortak utils/HoverPopover ile, FAZ-53/54 ikonlarıyla aynı
// davranış (dışarı tıkla / Escape kapatır, portal ile her şeyin üstünde).
//
// AÇILMA: yalnız TIKLAMA (`tiklaAc`) — kullanıcı kararı 2026-07-29. Bunlar bilgi
// baloncuğu değil AKSİYON baloncuğu ve listede satır satır dizili; imleç listede
// gezerken kendiliğinden açılıp altındaki işleri kapatıyordu. Kanal/okundu
// ikonlarının hover davranışı olduğu gibi duruyor.
//
// İki kullanım var:
//   SoruPopover  — hazır sorular; birine tıklayınca soru DOĞRUDAN gider
//                  (serbest metin kutusu YOK — kullanıcı kararı).
//   OnayPopover  — "ne olacak" bilgisi + tek "Onayla" düğmesi (İşe Başladım).

import React, { useState } from "react";

import HoverPopover from "../utils/HoverPopover";
import "./gorev.css";

/**
 * Hazır cümle listesi açan popover.
 *
 * İKİ YÖNDE kullanılır (2026-07-28): görevi VEREN "Ne durumdayız?" diye sorar,
 * işi YAPAN "Durum bildir" ile cevaplar. Yapı aynı, metinler taraf başına
 * değişir — bu yüzden başlık ve dipnot PROP'tur; varsayılanlar soran tarafındır.
 *
 * @param {node}     trigger  tıklanacak çip
 * @param {string[]} sorular  hazır cümleler
 * @param {func}     onSec    (cumle) => void — seçilen cümle doğrudan gönderilir
 */
export function SoruPopover({
  trigger,
  sorular,
  onSec,
  label = "Hazır sorular",
  baslik = "Ne sormak istersiniz?",
  dip = "Seçtiğiniz soru sorumluya anında iletilir.",
}) {
  return (
    <HoverPopover
      label={label}
      className="gk-pop-tetik"
      tiklaAc
      trigger={trigger}
      content={(kapat) => (
        <div className="gk-pop">
          <div className="gk-pop-baslik">{baslik}</div>
          <div className="gk-pop-liste">
            {sorular.map((s) => (
              <button
                key={s}
                type="button"
                className="gk-pop-satir"
                onClick={() => {
                  onSec(s);
                  kapat();
                }}
              >
                {s}
              </button>
            ))}
          </div>
          <div className="gk-pop-dip">{dip}</div>
        </div>
      )}
    />
  );
}

/**
 * Bilgi + tek onay düğmesi açan popover.
 * @param {node}   trigger
 * @param {string} baslik
 * @param {node}   bilgi      ne olacağını anlatan içerik
 * @param {string} onayLabel
 * @param {func}   onOnay     async olabilir
 */
export function OnayPopover({
  trigger,
  baslik,
  bilgi,
  onayLabel = "Onayla",
  onOnay,
  label = "Onay",
}) {
  const [gonderiliyor, setGonderiliyor] = useState(false);

  return (
    <HoverPopover
      label={label}
      className="gk-pop-tetik"
      tiklaAc
      trigger={trigger}
      content={(kapat) => (
        <div className="gk-pop">
          <div className="gk-pop-baslik">{baslik}</div>
          <div className="gk-pop-bilgi">{bilgi}</div>
          <button
            type="button"
            className="gk-pop-onay"
            disabled={gonderiliyor}
            onClick={async () => {
              setGonderiliyor(true);
              try {
                await onOnay();
                kapat();
              } finally {
                setGonderiliyor(false);
              }
            }}
          >
            {gonderiliyor ? "Gönderiliyor…" : onayLabel}
          </button>
        </div>
      )}
    />
  );
}
